import { Outlet } from 'react-router';
import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

export const NoAuthLayout = ({ children }: PropsWithChildren) => {
	return (
		<Layout
			style={{
				minHeight: '100svh',
				padding: 30,
				justifyContent: 'center',
				alignItems: 'center',
			}}>
			{children ?? <Outlet />}
		</Layout>
	);
};

export default NoAuthLayout;
